export const DESKTOP_QUERY = "(min-width: 768px)";